import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyResultsStepTranslations = wrapTranslationsSchema({
	name: 'BuyEasyResultsStepTranslations',
	title: 'Results Step Translations',
	sanityId: 'buyeasy-wizardResultsStep',
	fields: {
		buyingChannelsTitle: 'Choose a buying option',
		viewTheCatalog: 'View the Catalog',
		instructions: 'Instructions',
		continue: 'Continue',
		recommended: 'Recommended',
		summaryTitle: 'Summary',
		summaryApplicabilityYes: 'Yes',
		summaryApplicabilityNo: 'No',
		summaryYourProperties: 'Your Properties',
		summaryYourOptionsToBuy: 'Your options to buy',
		summaryBuyingInformation: 'Buying Information',
		summaryUser: 'User',
		summaryCountry: 'Country',
		summaryCategory: 'Category',
		summaryTPRM: 'TPRM',
		summaryValue: 'Value',
		summaryCpCode: 'CP Code',
		summaryGlAccounts: 'GL Accounts',
		summaryCompanyCode: 'Company Code',
		summaryLegalEntity: 'Legal Entity',
		summaryPurchasingOrg: 'Purchasing Org',
		summaryEstimatedValue: 'Estimated Value',
		summarySupplierId: 'Supplier ID',
		summarySupplier: 'Supplier',
		summarySearchForaUser: 'Search for a User',
		summaryApplicability: 'Applicability',
		modalHeading: 'Please update your Ariba propeties!',
		modalHeadingSelectAnotherSupplier: 'PLEASE SELECT ANOTHER SUPPLIER!',
		modalHeadingSelectASupplier: 'PLEASE SELECT A SUPPLIER!',
		selectASupplier: 'In order to proceed with Manual PR, you must first select a supplier...',
		supplierNotEnabled:
			'The selected supplier isn’t currently enabled for purchases in your company code and/or purchasing org. To create a purchase requisition in BuyEasy@Takeda, please return to the homepage and then find a supplier suitable for your company code and purchasing org before proceeding with your purchase.',
		userInformationMissing:
			'We identified that the following information is missing in your ARIBA user profile:',
		userProceed:
			'To proceed with your purchase requisition creation in BuyEasy@Takeda, please update your properties in ARIBA.',
		requesterMissingPropertiesHeader: 'SELECTED REQUESTER IS MISSING ARIBA PROPERTIES',
		requesterMissingPropertiesBody:
			'We identified that the following information is missing in the ARIBA profile of the selected requester:',
		requesterMissingPurchaseGroup: 'Purchase Group',
		requesterMissingPropertiesProceed:
			'To proceed with your purchase requisition creation in BuyEasy@Takeda, the requester must update their properties in ARIBA.',
		browsingAsCustom:
			'You are currently browsing with a custom selection of company code and purchasing org. To create a purchase requisition in BuyEasy@Takeda, please return to the homepage and select a specific user (yourself or a colleague who you are buying on behalf of).',
		goToInstructions: 'Instructions on how to update your profile',
		instructionsPageUrl:
			'https://takeda.service-now.com/tsp?id=kb_article_view&sysparm_article=KB1003687',
		goToHomepage: 'BuyEasy homepage',
		engageProcurementForSupportPowerAppUrl:
			'https://apps.powerapps.com/play/e/f74fb404-34f4-e4eb-8ea4-e7273c3eb751/a/1577de66-02a1-4d14-bd0b-011db2b29d91',
		searchBarTitle:
			'If you’re satisfied with the results, type your keyword and find your Supplier:',
		searchBarPlaceholder: 'Search for categories, CP codes, materials or services',
	},
});
